import Component from '../core/Component'
import debounce from 'lodash/debounce'
import { triggerEvent } from '../utils/dom'

export default class NumberInput extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            input: null,
            plus: null,
            minus: null
        }

        this.change = debounce(::this.change, 100)
    }

    prepare() {
        this.ref.plus.addEventListener('click', ::this.handlePlusClick)
        this.ref.minus.addEventListener('click', ::this.handleMinusClick)
    }

    handlePlusClick(event) {
        event.preventDefault()
        this.increment()
    }

    handleMinusClick(event) {
        event.preventDefault()
        this.decrement()
    }

    increment() {
        const value = parseInt(this.ref.input.value)
        let max = parseInt(this.ref.input.max)

        if (isNaN(value)) {
            value = 0
        }

        if (isNaN(max)) {
            max = Infinity
        }

        this.ref.input.value = value < max ? value + 1 : value
        this.change()
    }

    decrement() {
        const value = parseInt(this.ref.input.value)
        let min = parseInt(this.ref.input.min)

        if (isNaN(value)) {
            value = 0
        }

        if (isNaN(min)) {
            min = 1
        }

        this.ref.input.value = value > min ? value - 1 : value
        this.change()
    }

    change() {
        const event = document.createEvent('Event')
        event.initEvent('change', true, true)
        this.ref.input.dispatchEvent(event)
    }
}